import Model from "../Model";
import ValidatableObject from "../validation/ValidatableObject";

export interface TEvaluationTypeRuleGroup {
  id: number;
  evaluationTypeName: string;
  evaluationTypeDescription: string;
  weightThreshold: number;
  businessRuleGroupId: number;
  businessRuleGroupName: string;
  businessRuleGroupDescription: string;
}

export interface IEvaluationTypeRuleGroup extends TEvaluationTypeRuleGroup {}

const EvaluationTypeRuleGroup = Model(
  (model: TEvaluationTypeRuleGroup): IEvaluationTypeRuleGroup => {
    const _ruleGroup: TEvaluationTypeRuleGroup = Object.assign({}, model);
    let create = (
      ruleGroup: IEvaluationTypeRuleGroup
    ): IEvaluationTypeRuleGroup => {
      let obj = ValidatableObject(ruleGroup);
      return obj;
    };

    let ruleGroup = {
      get id() {
        return _ruleGroup.id;
      },
      set id(value) {
        _ruleGroup.id = value;
      },
      get evaluationTypeName() {
        return _ruleGroup.evaluationTypeName;
      },
      set evaluationTypeName(value) {
        _ruleGroup.evaluationTypeName = value;
      },
      get evaluationTypeDescription() {
        return _ruleGroup.evaluationTypeDescription;
      },
      set evaluationTypeDescription(value) {
        _ruleGroup.evaluationTypeDescription = value;
      },
      get businessRuleGroupId() {
        return _ruleGroup.businessRuleGroupId;
      },
      set businessRuleGroupId(value) {
        _ruleGroup.businessRuleGroupId = value;
      },
      get businessRuleGroupName() {
        return _ruleGroup.businessRuleGroupName;
      },
      set businessRuleGroupName(value) {
        _ruleGroup.businessRuleGroupName = value;
      },
      get businessRuleGroupDescription() {
        return _ruleGroup.businessRuleGroupDescription;
      },
      set businessRuleGroupDescription(value) {
        _ruleGroup.businessRuleGroupDescription = value;
      },
      get weightThreshold() {
        return _ruleGroup.weightThreshold;
      },
      set weightThreshold(value) {
        _ruleGroup.weightThreshold = value;
      }
    };

    return create(ruleGroup);
  }
);

export default EvaluationTypeRuleGroup;
